// 权限管理

import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// 进度条样式
import {removeUserInfo} from './utils/auth'
import {Message} from 'element-ui'

const whiteList = ['/login',]; // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start(); // 开启进度条
  if ( store.state.user.token ) { // 判断是否有token
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      if (store.getters.token) {                           // 判断是否已经有用户信息
        store.dispatch('GetUserMenu').then(res => {            // 获取用户菜单
          store.dispatch('GenerateRoutes', res ).then(() => {
            next()
          })
        }).catch(() => {
          store.dispatch('FedLogOut').then(() => {
            next({ path: '/login' });
            NProgress.done() // 结束进度条
          })
        })
      } else {
          next();
      }
    }
  }
  else {
    if (whiteList.indexOf(to.path) !== -1) { // 当前页是登录
      next();
    } else {
      /*Message({
        type: 'error',
        message: '用户信息过期，请重新登录',
      });*/
      NProgress.done() // 结束进度条
      next('/login'); // 登录页
    }
    removeUserInfo();
  }
});

router.afterEach(() => {
  NProgress.done() // 结束进度条
});



// WEBPACK FOOTER //
// ./src/permission.js